import { momentFormatted } from 'kb-shared/utilities/momentHelpers';

export const formatDate = (date: string | null) =>
  date ? momentFormatted(date, 'MM/DD/YYYY') : '-';
